// An error that takes a name in the constructor
export class NamedError<T extends string> extends Error {
    constructor(name: T, message?: string) {
        super(message);
        this.name = name;
    } 
}

export class NetworkError extends NamedError<NetworkErrors> {}

export enum NetworkErrors {
    NoInternetConnection = "NoInternetConnection"
}